var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 커뮤니티 회원가입 - 완료 컴포넌트
 *
 ********************************************************************/
import { useState } from "react";
// recoil
import { useRecoilState } from "recoil";
import { authId } from "../../../../recoil/userState";
//utils
import { Trans } from "react-i18next";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { useTrans } from "../../../../utils/langs/useTrans";
export default function CmmJoinDonePop(props) {
    const t = useTrans();
    //recoil
    const [userId, setUserId] = useRecoilState(authId);
    const [success, setSuccess] = useState("");
    // 인증 발송 API
    function onClickJoinDone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/auth/key",
                appQuery: {
                    userId: userId,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSuccess(data.body);
                }
                else {
                    alert(data.errorList.map((err) => err.msg));
                }
            }
        });
    }
    // 재발송 API
    function onClickJoinDoneRe(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/auth/key",
                appQuery: {
                    userId: userId,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSuccess(data.body);
                    alert(t("회원가입완료.전송완료"));
                }
                else {
                    alert(data.errorList.map((err) => err.msg));
                }
            }
        });
    }
    function Close(id) {
        setSuccess("");
        setUserId("");
        CUTIL.jsclose_Popup(id);
        location.reload();
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "cmm-join-ok", className: "popup-layer js-layer hidden inner-popup popup-basic pop-login w350" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("회원가입완료.TITLE") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("cmm-join-ok") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body joinok-h " }, { children: _jsxs("div", Object.assign({ className: "complete-txt" }, { children: [_jsx(Trans, Object.assign({ i18nKey: success.length <= 0 ? "회원가입완료.미발송" : "회원가입완료.발송", values: { userId: userId } }, { children: success.length <= 0 ? (_jsxs("p", Object.assign({ className: "joinok" }, { children: ["\uD68C\uC6D0\uAC00\uC785\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.", _jsx("br", {}), "\u2018", userId, "\u2019 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uBA54\uC77C\uC774 \uC804\uC1A1 \uB429\uB2C8\uB2E4."] }))) : (_jsxs("p", Object.assign({ className: "joinok" }, { children: ["\u2018", userId, "\u2019 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uBA54\uC77C\uC774 \uC804\uC1A1 \uB418\uC5C8\uC2B5\uB2C8\uB2E4."] }))) })), success.length > 0 ? (_jsx("button", Object.assign({ type: "button", onClick: onClickJoinDoneRe }, { children: _jsx("span", { children: t("회원가입완료.재발송") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: onClickJoinDone }, { children: _jsx("span", { children: t("회원가입완료.인증메일발송") }) })))] })) }))] })) }));
}
